import {Box} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {XXL_BREAKPOINT_MAX} from "../../../config/constants"

export const InnerContainer = styled("nav", {
    shouldForwardProp: prop => prop !== "xxlBreakpointEnabled",
})<{xxlBreakpointEnabled: boolean}>`
    display: flex;
    height: 2.75rem;
    flex: 1 1 0;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    max-width: ${({xxlBreakpointEnabled}) => (xxlBreakpointEnabled ? XXL_BREAKPOINT_MAX : breakpoints.values.xl)}px;
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.borderColor};

    padding: 0.4rem 0.25rem;

    @media (min-width: ${breakpoints.values.md}px) {
        height: 3.75rem;
        padding: 0.75rem 2rem 0.25rem 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        height: 3.75rem;
        padding: 0.75rem 2.5rem 0.25rem 2.5rem;
    }

    .header-adaptive-checkout {
        flex-shrink: 0;
    }
`
export const LeftSideContainer = styled("div")`
    flex: 1 1 0;
    display: flex;
    align-items: center;
    margin-left: 0.25rem;

    @media (min-width: ${breakpoints.values.md}px) {
        margin-left: 0;
    }
`
export const RightSideContainer = styled("div")`
    flex: 1 1 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 0.25rem;

    @media (min-width: ${breakpoints.values.md}px) {
        margin-right: 0;
    }
`

export const IconGroupContainer = styled(Box)`
    @media (min-width: ${breakpoints.values.md}px) {
        display: flex !important;
        gap: 4px;
        margin-right: 4px;
        background-color: inherit;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        gap: 8px;
        margin-right: 8px;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        gap: 16px;
        margin-right: 16px;
    }
`

export const ShoppingBagWrapper = styled("span")`
    @media (min-width: ${breakpoints.values.md}px) {
        margin-right: 4px;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        margin-right: 8px;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        margin-right: 16px;
    }
`

export const HeaderContainer = styled("header")`
    box-shadow: ${({theme}) => theme.uxfabric.elevation.header};
`
